exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h4.modal-title {\r\n    margin-top: 0;\r\n    font-size: 24px;\r\n    color: #555;\r\n    font-weight: 400;\r\n}\r\n\r\nbutton.close:hover {\r\n    color: var(--primary-orange);\r\n}\r\n\r\nbutton.close {\r\n    position: relative;\r\n    border: 0;\r\n    color: #555;\r\n    font-size: 40px;\r\n    -webkit-transition: all .3s linear;\r\n    transition: all .3s linear;\r\n    background: transparent;\r\n    cursor: pointer;\r\n}\r\n\r\nbutton.btn.btn-success:hover, .register-container button:hover {\r\n    background: #58ca5d;\r\n}\r\n\r\n.modal-dialog {\r\n    padding-bottom: 30px;\r\n}\r\n\r\n.modal-content button.close{\r\n    right: 10px;\r\n    top: 5px;\r\n    z-index: 1;\r\n}\r\n\r\n.input-group:focus-within  .input-group-prepend i {\r\n    color: var(--primary-orange);\r\n    -webkit-transition: all 300ms;\r\n    transition: all 300ms;\r\n}\r\n\r\n.form-control {\r\n    margin-left: 48px;\r\n    border: none;\r\n}\r\n\r\n.button-wrapper button {\r\n    background: #4CAF50;\r\n    width: 100%;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Authentication/components/login/login.component.css
// module id = ../../../../../src/app/Modules/Authentication/components/login/login.component.css
// module chunks = main